import { AssumptionsExclusionsDataImport } from "./assumptions-exclusions-data-import";

import React, { useState } from "react";
import { LIBRARY_ASSUMPTIONS_QUERY, MATTER_ASSUMPTIONS_QUERY } from "../../../graphql/query";
import { useMutation, useQuery } from "@apollo/client";
import { UPDATE_LIBRARY_ASSUMPTIONS, CREATE_LIBRARY_ASSUMPTION } from "../../../graphql/mutation";
import { VpdDataImportType } from "../../../graphql/__generated_types__/globalTypes";
import {
  LibraryAssumptionWhereInput,
  UpdateLibraryAssumptionsMutation,
  UpdateLibraryAssumptionsMutationVariables,
} from "~/gql/graphql";

import {
  FindLibraryAssumptions,
  FindLibraryAssumptionsVariables,
} from "@graphql-types/FindLibraryAssumptions";
import {
  CreateLibraryAssumption,
  CreateLibraryAssumptionVariables,
} from "@graphql-types/CreateLibraryAssumption";

export const AssumptionsDataImportWrapper = () => {
  const [orgUnitFilter, setOrgUnitFilter] = useState<number | null>(null);

  const filter: LibraryAssumptionWhereInput =
    orgUnitFilter === 0
      ? { organisationalUnits: { none: {} } }
      : orgUnitFilter !== null
      ? {
          organisationalUnits: { some: { id: { equals: orgUnitFilter } } },
        }
      : {};

  const { loading: queryLoading, data } = useQuery(LIBRARY_ASSUMPTIONS_QUERY, {
    variables: {
      filter,
    },
  });

  const { refetch: refetchMatterAssumptions } = useQuery(MATTER_ASSUMPTIONS_QUERY);

  const [updateLibraryAssumptions, { loading: updateLoading }] = useMutation<
    UpdateLibraryAssumptionsMutation,
    UpdateLibraryAssumptionsMutationVariables
  >(UPDATE_LIBRARY_ASSUMPTIONS, {
    refetchQueries: [LIBRARY_ASSUMPTIONS_QUERY],
  });

  const [createLibraryAssumption] = useMutation<
    CreateLibraryAssumption,
    CreateLibraryAssumptionVariables
  >(CREATE_LIBRARY_ASSUMPTION, {
    update(cache, { data }) {
      if (!data?.createLibraryAssumption) return;
      const existingData = cache.readQuery<FindLibraryAssumptions, FindLibraryAssumptionsVariables>(
        {
          query: LIBRARY_ASSUMPTIONS_QUERY,
          variables: {
            filter: {},
          },
        }
      );
      cache.writeQuery<FindLibraryAssumptions, FindLibraryAssumptionsVariables>({
        query: LIBRARY_ASSUMPTIONS_QUERY,
        variables: {
          filter: {},
        },
        data: {
          libraryAssumptions: [
            ...(existingData?.libraryAssumptions || []),
            data.createLibraryAssumption,
          ],
        },
      });
    },
  });

  return (
    <AssumptionsExclusionsDataImport
      type={VpdDataImportType.LibraryAssumption}
      items={data?.libraryAssumptions || []}
      updateLibraryItem={({ variables, onCompleted }) => {
        updateLibraryAssumptions({
          variables,
          onCompleted: (data) => {
            if (onCompleted) {
              onCompleted();
            }
            const updatedMatterIds = data?.updateLibraryAssumptions.matterIds || [];
            updatedMatterIds.forEach((matterId) => {
              refetchMatterAssumptions({ input: matterId });
            });
          },
        });
      }}
      createLibraryItem={({ variables, onCompleted }) => {
        createLibraryAssumption({ variables, onCompleted });
      }}
      handleOrgUnitFilterChange={(value) => setOrgUnitFilter(value)}
      updateLoading={updateLoading}
      queryLoading={queryLoading}
    />
  );
};
